"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStylesValues = void 0;
var tslib_1 = require("tslib");
var createStyleParamGetter_1 = require("./styles/createStyleParamGetter");
function getStylesValues(styles, params, options) {
    if (options === void 0) { options = {}; }
    var acc = {};
    Object.keys(params).forEach(function (paramKey) {
        var param = params[paramKey];
        acc[param.key] = (0, createStyleParamGetter_1.createStyleParamGetter)(tslib_1.__assign({ storage: styles }, options))(param);
    });
    return acc;
}
exports.getStylesValues = getStylesValues;
//# sourceMappingURL=getStylesValues.js.map